
import api from "~api";
import XHeader from 'vux/src/components/x-header/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

export default {
name: "dailyuse-book",
components: {
XHeader,Alert,CheckIcon
},
directives: {
TransferDom
},
computed:{
total:function () {
var tmp=0;
this.idArr = "";
for (var i=0;i<this.optionalgoods.length;i++){
if(this.optionalgoods[i].checked==true){
tmp+=parseInt(this.optionalgoods[i].packagePrice);
this.idArr = this.idArr + this.optionalgoods[i].id + ",";
}
}
for (var i=0;i<this.mustgoods.length;i++){
tmp+=parseInt(this.mustgoods[i].packagePrice);
this.idArr = this.idArr + this.mustgoods[i].id + ",";
}
return tmp;
}
},
created() {
this.getData();
},
data(){
return{
title:"生活用品预订",
goods: [],
mustgoods:[














],
optionalgoods:[
















],
packagedetail:'',
show:false,
checked:false,
packageType:"",
idArr:"",
editBool:true
}
},
methods:{
getData(){
api.post("/findStuInfo", {"stuCode": window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data!=null){
if(res.data.data.deptName.indexOf("国际")!=-1){

this.packageType = "2";
}else{

this.packageType = "1";
}
api.post("/Livings/livingCost", {"packageType": this.packageType}).then( res=>{
if(res.data!=null){
var list = res.data.results;
for(var i=0;i<list.length;i++){

var num = i;
if(list[i].packageType=="0"){
this.optionalgoods.push(list[i]);
}else{
this.mustgoods.push(list[i]);
}
}


api.post("/Livings/findReserve ", {"stuCode":window.localStorage.getItem("stuCode")}).then( res=>{
if(res.data!=null){
if(res.data.results==null){
this.editBool = false;
}else{
var ids = res.data.results.packageId.split(",");
for(var j=0;j<ids.length;j++){
for(var k=0;k<this.optionalgoods.length;k++){
if(ids[j]==this.optionalgoods[k].id){
this.$set(this.optionalgoods[k],"checked",true)
}
}
}
}

}
})
}
})



}
})

},
gotoconfirm(){
this.$router.push('/pay');
},
onHide () {
console.log('on hide')
},
onShow () {
console.log('on show')
},
showdetail(item){
this.packagedetail = item.packageContent;
this.show = true;
},
goNext () {
var _this = this;
var flowdata = JSON.parse(window.localStorage.getItem('flowdata'));
/*_this.$vux.loading.show({
text: 'Loading'
})
welcomeapi.welcomepost('/NewReports/addInformation',
{
"stuCode":_this.$store.state.stu_num,
"stuName":_this.stuinfo.name,
/!*"stuCode":'1801010122',
"stuName":'皮皮虾',*!/
"weChat":_this.stuinfo.wechat,
"email":_this.stuinfo.email,
"phone":_this.stuinfo.phone,
"dName":_this.stuinfo.dname,
"dRelation":_this.stuinfo.drelate,
"dPhone":_this.stuinfo.dphone,
"mName":_this.stuinfo.mname,
"mRelation":_this.stuinfo.mrelate,
"mPhone":_this.stuinfo.mphone
}
).then(function (response) {
var data = response.data;
console.log(response.data);

if (data.result == true){
_this.$vux.loading.hide()
_this.$router.push({name: 'schoolInformation'});
}else {
_this.$msgbox('温馨提示：',"您的信息不完善");
_this.$vux.loading.hide()
}
})*/
var sort = _this.$route.params.sort;
var urlname = '';
var stunum = _this.$route.params.stunum;
for (var i = 0;i<flowdata.length;i++){
if(flowdata[i].sort>sort){
sort = flowdata[i].sort;
urlname = flowdata[i].urlname;
_this.$router.push({name: urlname,params:{sort:sort,stunum:stunum}});
return;
}/*else{
_this.$router.push({name: 'generateform',params:{stunum:stunum}});
}*/
}
},
doSubmit(){
var params = {
"stuCode":window.localStorage.getItem("stuCode"),
"processId":this.$route.params.sort,
"packageId":this.idArr
};
console.log(JSON.stringify(params))
if(this.editBool){
console.log("==="+this.idArr)
api.post("/Livings/updateReserve", params).then( res=>{
if(res.data!=null){
if(res.data.results){
this.goNext();
}else{
this.$msgbox('温馨提示：',"信息修改失败！");
}
}
})
}else{
api.post("/Livings/addReserve", params).then( res=>{
if(res.data!=null){
if(res.data.results){
this.goNext();
}else{
this.$msgbox('温馨提示：',"信息保存失败！");
}
}
})
}

}
}
}



// WEBPACK FOOTER //
// ./src/components/newstu/livinguse.vue